import { render, staticRenderFns } from "./anzera-question-card.vue?vue&type=template&id=42629e74&scoped=true"
import script from "./anzera-question-card.vue?vue&type=script&lang=js"
export * from "./anzera-question-card.vue?vue&type=script&lang=js"
import style0 from "./anzera-question-card.vue?vue&type=style&index=0&id=42629e74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42629e74",
  null
  
)

export default component.exports